import React from "react";
import HeaderBar from "../components/Navigation";


const LandingLayout = (ViewComponent) => {
    return class extends React.Component {
        render() {
            return (
                <div className="ml-0 w-100 h-100">
                    {/* <Import the nav bar> */}
                <HeaderBar />
                <div className="ml-0 mr-0 p-0  w-100 h-100">
                    <ViewComponent />
                </div>
            </div>
        );
        }
    };
};

export default LandingLayout;
